import styled from "styled-components";

export const StyledMoreActions = styled.span`
	display: inline-flex;
	cursor: pointer;
	padding: 0 0.2rem;
	margin-right: 0.4rem;
	justify-content: center;
	align-items: center;
	position: ${(props) => props.moreActionsPosition};
	top: ${(props) => (props.moreActionsPosition === "relative" ? "0" : "50%")};
	transform: ${(props) => (props.moreActionsPosition === "relative" ? "none" : "translateY(-50%)")};
	right: ${(props) => (props.moreActionsPosition === "relative" ? "0" : "1.8rem")};
`;
